import React from 'react'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

export function EventEnded() {
  const {t} = useI18n()
  return (
    <div className="create__event-area mb-20 col-12">
      <div className="body__card-wrapper attendant__wrapper">
        <EventStatusHolder>
          <div>
            <p>
              <b>{t('orgEventBilling.statusLabel')} </b>
              <b style={{color: 'red'}}>{t('orgEventBilling.inactive')}</b>
            </p>
          </div>
        </EventStatusHolder>
      </div>
    </div>
  )
}

const EventStatusHolder = styled.div`
  align-items: center;
`
